<script>
  import {
    BizcardRoutingCreateForm,
    BizcardRoutingDeleteForm,
    BizcardRoutingPriorityForm,
    BizcardRoutingUpdateForm,
    BizcardStudioCloneForm,
    BizcardStudioCreateForm,
    BizcardStudioDeleteForm,
    BizcardStudioUpdateForm,
    CampaignCloneForm,
    CampaignCreateForm,
    CampaignDeleteForm,
    CampaignUpdateForm,
    DocumentCreateForm,
    DocumentDeleteForm,
    DocumentUpdateForm,
    DomainBillingUpdateForm,
    DomainCloneForm,
    DomainCreateForm,
    DomainMdmForm,
    DomainSettingsUpdateForm,
    GroupCloneForm,
    GroupCreateForm,
    GroupDeleteForm,
    GroupUpdateForm,
    ImageBulkCreateForm,
    ImageDeleteForm,
    ImageSingleCreateForm,
    ImageUpdateForm,
    IntegrationCreateForm,
    IntegrationDeleteForm,
    IntegrationUpdateForm,
    SignatureActionsForm,
    SignatureCreateForm,
    SignatureDeleteForm,
    SignaturePushNewForm,
    SignaturePushRepeatForm,
    SignatureRoutingCreateForm,
    SignatureRoutingDeleteForm,
    SignatureRoutingPriorityForm,
    SignatureRoutingUpdateForm,
    SignatureUpdateForm,
    TargetingCreateForm,
    TargetingDeleteForm,
    TargetingGroupPriorityForm,
    TargetingUpdateForm,
    UserActionsForm,
    UserRemoveAdminRolesForm,
    UserSyncForm,
    UserUpdateForm,
    VideoCreateForm,
    VideoDeleteForm,
    VideoUpdateForm
  } from './forms';

  /**
   * Workflow step configuration object containing action and data.
   * @type {Object}
   */
  export let step;

  /**
   * Controls whether the next button in the workflow step is disabled.
   * @type {boolean}
   * @default true
   */
  export let nextDisabled = true;

  /**
   * Callback function invoked when the workflow step executes.
   * @type {Function | null}
   * @default null
   */
  export let onExecute = null;

  /**
   * Callback function invoked when the workflow step is rolled back.
   * @type {Function | null}
   * @default null
   */
  export let onRollback = null;

  if (!step.data) {
    step.data = {};
  }

  let stepExecuteFunction = null;
  let stepRollbackFunction = null;

  const handleExecute = (executeFn) => {
    stepExecuteFunction = executeFn;
    if (onExecute) {
      onExecute(executeFn);
    }
  };

  const handleRollback = (rollbackFn) => {
    stepRollbackFunction = rollbackFn;
    if (onRollback) {
      onRollback(rollbackFn);
    }
  };

  $: actionValue = step.action?.value || step.action;

  const formComponents = {
    bizcard_clone: BizcardStudioCloneForm,
    bizcard_create: BizcardStudioCreateForm,
    bizcard_delete: BizcardStudioDeleteForm,
    bizcard_update: BizcardStudioUpdateForm,
    bizcard_route_create: BizcardRoutingCreateForm,
    bizcard_route_delete: BizcardRoutingDeleteForm,
    bizcard_route_priority: BizcardRoutingPriorityForm,
    bizcard_route_update: BizcardRoutingUpdateForm,
    campaign_clone: CampaignCloneForm,
    campaign_create: CampaignCreateForm,
    campaign_delete: CampaignDeleteForm,
    campaign_update: CampaignUpdateForm,
    document_create: DocumentCreateForm,
    document_delete: DocumentDeleteForm,
    document_update: DocumentUpdateForm,
    domain_billing_update: DomainBillingUpdateForm,
    domain_clone: DomainCloneForm,
    domain_create: DomainCreateForm,
    domain_mdm: DomainMdmForm,
    domain_settings_update: DomainSettingsUpdateForm,
    group_clone: GroupCloneForm,
    group_create: GroupCreateForm,
    group_delete: GroupDeleteForm,
    group_update: GroupUpdateForm,
    image_bulk_create: ImageBulkCreateForm,
    image_delete: ImageDeleteForm,
    image_single_create: ImageSingleCreateForm,
    image_update: ImageUpdateForm,
    integration_create: IntegrationCreateForm,
    integration_delete: IntegrationDeleteForm,
    integration_update: IntegrationUpdateForm,
    signature_archive: SignatureActionsForm,
    signature_clone: SignatureActionsForm,
    signature_clone_domain: SignatureActionsForm,
    signature_create: SignatureCreateForm,
    signature_delete: SignatureDeleteForm,
    signature_update: SignatureUpdateForm,
    signature_push: SignaturePushNewForm,
    signature_push_repeat: SignaturePushRepeatForm,
    signature_route_create: SignatureRoutingCreateForm,
    signature_route_delete: SignatureRoutingDeleteForm,
    signature_route_priority: SignatureRoutingPriorityForm,
    signature_route_update: SignatureRoutingUpdateForm,
    signature_unarchive: SignatureActionsForm,
    targeting_create: TargetingCreateForm,
    targeting_delete: TargetingDeleteForm,
    targeting_group_priority: TargetingGroupPriorityForm,
    targeting_update: TargetingUpdateForm,
    user_create: UserSyncForm,
    user_disable: UserActionsForm,
    user_enable: UserActionsForm,
    user_reminder: UserActionsForm,
    user_remove_admin_roles: UserRemoveAdminRolesForm,
    user_update: UserUpdateForm,
    video_create: VideoCreateForm,
    video_delete: VideoDeleteForm,
    video_update: VideoUpdateForm
  };

  $: FormComponent = formComponents[actionValue];
</script>

<div class="step-content">
  {#if FormComponent}
    <svelte:component
      this={FormComponent}
      bind:nextDisabled
      bind:step
      onExecute={handleExecute}
      onRollback={handleRollback}
    />
  {:else}
    <div class="placeholder">
      <p>Form for <strong>{actionValue}</strong> is not yet implemented.</p>
      <p class="text-muted">This action will be available soon.</p>
    </div>
  {/if}
</div>

<style lang="scss">
  .step-content {
    padding: var(--padding-large) 0;
  }

  .placeholder {
    padding: var(--padding-xlarge);
    text-align: center;
    color: var(--color-gray-600);

    p {
      margin-bottom: var(--margin-small);

      &:last-child {
        margin-bottom: 0;
      }
    }

    strong {
      color: var(--color-gray-800);
    }

    .text-muted {
      font-size: var(--font-size-small);
    }
  }
</style>
